export const GET_CUSTOMERS = 'GET_CUSTOMERS';